var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"inline-block lg:block mr-2 lg:leading-none mt-1"},[_c('div',{staticClass:"text-sm text-gray-700"},[_vm._v(_vm._s(_vm.number))])])}
var staticRenderFns = []

export { render, staticRenderFns }